module.exports = __webpack_public_path__ + "static/media/riven-win.a085b1d0.png";